import { render, staticRenderFns } from "./ApproverReport.vue?vue&type=template&id=49467b16"
import script from "./ApproverReport.vue?vue&type=script&lang=js"
export * from "./ApproverReport.vue?vue&type=script&lang=js"
import style0 from "./ApproverReport.vue?vue&type=style&index=0&id=49467b16&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports